/**
 * Utilidades para colores semánticos de TextListWithData
 */

import { TextListWithDataColor } from '../types';

/**
 * Mapeo de colores semánticos a variables CSS del sistema de diseño
 */
export const SEMANTIC_COLOR_MAP: Record<TextListWithDataColor, string> = {
  brand: 'var(--ui-color-blue-500)',
  success: 'var(--ui-color-green-500)',
  warning: 'var(--ui-color-orange-500)',
  danger: 'var(--ui-color-red-500)',
  info: 'var(--ui-color-cyan-500)',
  neutral: 'var(--ui-color-light-gray-500)',
  yellow: 'var(--ui-color-yellow-500)',
} as const;

/**
 * Obtiene el valor CSS del color semántico
 */
export const getColorValue = (color: TextListWithDataColor): string => {
  return SEMANTIC_COLOR_MAP[color] || SEMANTIC_COLOR_MAP.neutral;
};
